import { Injectable } from '@angular/core';
import { DealerServiceFilterModel } from 'projects/Widget/src/app/business-entities/dealer-service-filter-model';
import { GenericResponse } from '../business-entities/generic-response';
import { ServiceDetails, ServiceViewModel } from '../business-entities/service-view-model';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({
    providedIn: 'root'
})

export class ServiceDataService
{
    constructor(private dataProvider: DataService) {
    }

    async getService(language: string,status:number,isForDropDown:boolean): Promise<GenericResponse<Array<ServiceViewModel>>> {
        return this.dataProvider.Get<GenericResponse<Array<ServiceViewModel>>>(Urls.GetService,language,status,isForDropDown).toPromise();
    }

    async getServiceList(serviceListRequest: any): Promise<GenericResponse<Array<ServiceViewModel>>> {
        return this.dataProvider.Post<GenericResponse<Array<ServiceViewModel>>>(Urls.GetService,serviceListRequest).toPromise();
    }

    AddUpdateService(ServiceModel: any): Promise<GenericResponse<ServiceViewModel>> {
        return this.dataProvider.Post<GenericResponse<ServiceViewModel>>(Urls.AddUpdateService, ServiceModel).toPromise();
    }

    async GetServiceById(ServiceId: number): Promise<GenericResponse<ServiceDetails>> {
        return this.dataProvider.Get<GenericResponse<ServiceDetails>>
        (Urls.GetServiceById, ServiceId).toPromise();
    }
    getServiceCategory(LanguageCode: string){
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetServiceCategory, LanguageCode).toPromise();
    }

    getCompetence(status:number)
    {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetCompetence,status).toPromise();
    }

    deleteService(Id: number):Promise<GenericResponse<boolean>> {
        return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeleteService, Id).toPromise();
    }
    GetServiceTimeDetails(ServiceId: number): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>
        (Urls.GetServiceTimeDetails, ServiceId).toPromise();
    }
    GetServicesByDealerId(dealerServiceFilterModel:DealerServiceFilterModel): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetServicesByDealerId,dealerServiceFilterModel).toPromise();
      }
      getDiagnoseCheckListForService(LanguageCode: string){
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetDiagnoseCheckListForService, LanguageCode).toPromise();
    }
}
